import gql from 'graphql-tag';

import userFragment from './user-fragment';

export default gql`
  mutation setActivationEmailUserMutation($email: String!) {
    setActivationEmailUserMutation(email: $email) {
      title
      message
    }
  }
`;
